export var logError = function (err, info) {
    if (info === void 0) { info = { componentStack: '' }; }
    console.error(err);
};
